<template>
  <section class="incentive-screen" v-if="userData">
    <h1 class="title">Incentivos</h1>
    <div class="card">
      <div class="row">
        <div class="label">Licencia</div>
        <div class="value">{{ userData.licencia }}</div>
      </div>
      <div class="row">
        <div class="label"># Viajes</div>
        <div class="value">{{ userData.viajes }}</div>
      </div>
      <div class="row">
        <div class="label">Rango</div>
        <div class="value">{{ userData.tier }}</div>
      </div>
      <div class="row">
        <div class="label"># Viajes para el siguiente rango</div>
        <div class="value">{{ userData.cuanto_falta }}</div>
      </div>
      <div class="row">
        <div class="label">Bono a cobrar</div>
        <div class="value">{{ userData.bono }}</div>
      </div>
    </div>
  </section>
  <section v-else>
    <p>Loading data...</p>
  </section>

  <!-- Mensaje fijo abajo y centrado -->
  <div class="fixed-message">
  Para dudas o para reclamar su bono, comuníquese por Whatsapp al siguiente número: 
  <a 
    href="https://wa.me/51910937866" 
    target="_blank" 
    rel="noopener noreferrer"
    class="whatsapp-link"
  >
    910937866
  </a>
</div>
</template>

<script>
export default {
  name: "IncentiveScreen",
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.incentive-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem 3rem;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
  background-color: #fafafa;
  min-height: 100vh;
  box-sizing: border-box;
}

.title {
  font-size: 2rem;
  font-weight: 600;
  color: #404040;
  margin-bottom: 2.5rem;
  user-select: none;
}

.card {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #e2e2e2;
}

.row {
  border-bottom: 1px solid #e5e5e5;
  padding: 18px 24px;
  display: flex;
  flex-direction: column;
}

.row:last-child {
  border-bottom: none;
}

.label {
  font-size: 0.85rem;
  color: #7a7a7a;
  font-weight: 600;
  text-transform: capitalize;
  margin-bottom: 6px;
  letter-spacing: 0.03em;
  font-feature-settings: "liga" off; /* evitar ligaduras molestas */
}

.value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #111;
  line-height: 1.2;
  user-select: text;
}

/* Para dispositivos pequeños aún dar el 90% ancho con un máximo y buen padding */
@media (max-width: 400px) {
  .card {
    max-width: 90vw;
    border-radius: 14px;
    padding: 0;
  }
  .row {
    padding: 16px 1.25rem;
  }
}

/* Estilos para el mensaje fijo inferior */
.fixed-message {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #222;
  color: #fff;
  padding: 0.7rem 1.2rem;
  font-size: 0.95rem;
  text-align: center;
  width: 100%;
  max-width: 600px;
  box-sizing: border-box;
  user-select: none;
  z-index: 1000;
}

.whatsapp-link {
  color: #25D366; /* Verde WhatsApp */
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
  user-select: text;
}

.whatsapp-link:hover {
  opacity: 0.8;
}
</style>